import React, { useEffect, useRef, useState } from 'react';
import './App.css';
import Navigation from '../common/Navigation';
import ScrollToTop from '../shared/ScrollToTop';
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import Home from '../pages/Home';
import Categoies from '../pages/Categories';
import Contact from '../pages/Contact';
// import { usePWAInstall } from 'react-use-pwa-install'
import ShoppingCart from './../pages/ShoppingCart';
import Products from '../pages/Products';
import Account from '../pages/Account';
import UserInfo from '../pages/UserInfo';
import SearchContext from '../../context/searchContext';
import { requestCanceller } from '../../service/axiosCancelToken';
import { getProductArchive } from '../../service/productService';
import toast from 'react-hot-toast';
import { charsNormalize } from '../../util/charactorsNormalize';
import Search from '../pages/Search';
import SuccessfullOrder from '../orders/SuccessOrder';
import UserOrders from '../userOrders/UserOrders';

function App() {

  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [isSearching, setIsSearching] = useState(false);
  const timoutRef = useRef(null);
  const [searchInput, setSearchInput] = useState('');
  const [products, setProducts] = useState();
  const [lastProductObj, setLastProductObj] = useState();
  const [hasMore, setHasMore] = useState(false);
  const [perPage] = useState(window.innerWidth >= 576 ? 25 : 15);


  useEffect(() => {
    if (!hasMore) return;
    const cancelRequest = requestCanceller();
    const fetchProducts = async () => {
      try {
        const params = {
          searchText: searchInput,
          perPage: perPage,
          lastProductObj: lastProductObj ? JSON.stringify(lastProductObj) : undefined,
          forceActive: true
        };
        let { status, data } = await getProductArchive(params, { signal: cancelRequest.signal });
        if (status === 201) {
          setProducts((prev) => {
            if (
              !prev ||
              !prev.length ||
              (prev.length && !lastProductObj)
            ) {
              return data.products;
            } else {

              let allproducts = prev.concat(data.products);
              return allproducts;
            }
          });
          if (data.products.length < perPage) {
            setHasMore(false);
          }
          setIsSearching(false);
        }
      } catch (err) {
        toast.error(err)
        setIsSearching(false)
      }
    };

    fetchProducts()
    // return () => cancelRequest.cancel();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasMore, lastProductObj]);

  const onChangeSearch = (value) => {
    if (isSearching) {
      return;
    }
    setHasMore(false);
    clearTimeout(timoutRef.current);
    setSearchInput(charsNormalize(value));
    setLastProductObj();
  };

  useEffect(() => {
    if (!searchInput) {
      return;
    }
    if (pathname !== '/search') {
      setProducts();
      navigate('/search');
    }

    timoutRef.current = setTimeout(() => {
      setIsSearching(true);
      setProducts();
      setHasMore(true)
    }, searchInput ? 800 : 100);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchInput])

  const fetchMoreData = async () => {
    const lastProductObj = {
      priority: products[products.length - 1].priority,
      _id: products[products.length - 1]._id
    };
    setLastProductObj(lastProductObj);
  };


  return (
    <div className="App container">
      <SearchContext.Provider
        value={{
          searchInput: searchInput,
          setSearchInput: setSearchInput,
          onChangeSearch: onChangeSearch,
          products: products,
          setProducts: setProducts,
          hasMore: hasMore,
          setHasMore: setHasMore,
          fetchMoreData: fetchMoreData,
          isSearching: isSearching,
          perPage: perPage
        }}
      >
        <header>
          <Navigation />
        </header>
        <ScrollToTop />
        <div className='content-layer'>
          <Routes>
            <Route path="/categories" element={<Categoies />} />
            <Route path="/products/*" element={<Products />} />
            <Route path="/search/*" element={<Search />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/cart" element={<ShoppingCart />} />
            <Route path="/success-order" element={<SuccessfullOrder />} />
            <Route path="/account-menu" element={<Account />} />
            <Route path="/userInfo" element={<UserInfo />} />
            <Route path="/userOrders" element={<UserOrders />} />
            <Route path='/' exact={true} element={<Home />} />
            <Route path="*" element={<Navigate replace to='/' />} />
          </Routes>
        </div>
      </SearchContext.Provider>
    </div>

  );
}

export default App;
